var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.662a2.733 2.733 0 0 1-.79-.116l-8-2.4a2.734 2.734 0 0 1-1.96-2.634V4.688a2.749 2.749 0 0 1 3.54-2.634l6.852 2.055a1.23 1.23 0 0 0 .716 0l6.852-2.055a2.749 2.749 0 0 1 3.54 2.634v12.824a2.734 2.734 0 0 1-1.96 2.634l-8 2.4a2.733 2.733 0 0 1-.79.116zM4 3.437a1.252 1.252 0 0 0-1.25 1.251v12.824a1.242 1.242 0 0 0 .892 1.2l8 2.4a1.23 1.23 0 0 0 .716 0l8-2.4a1.242 1.242 0 0 0 .892-1.2V4.688a1.249 1.249 0 0 0-1.608-1.2L12.79 5.546a2.742 2.742 0 0 1-1.58 0L4.358 3.491A1.261 1.261 0 0 0 4 3.437z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.66a.75.75 0 0 1-.75-.75v-17a.75.75 0 0 1 1.5 0v17a.75.75 0 0 1-.75.75zM15.5 11.61a1.249 1.249 0 0 1-1.247-1.251V8.391a1.249 1.249 0 0 1 .947-1.213l3-.75a1.249 1.249 0 0 1 1.55 1.213v1.968a1.249 1.249 0 0 1-.947 1.213l-3 .75a1.233 1.233 0 0 1-.303.038zm.253-3.025v1.455l2.5-.625V7.96zM15 14.75a.75.75 0 0 1-.181-1.478l4-1a.75.75 0 0 1 .364 1.456l-4 1a.763.763 0 0 1-.183.022zM15 17.75a.75.75 0 0 1-.181-1.478l4-1a.75.75 0 0 1 .364 1.456l-4 1a.763.763 0 0 1-.183.022zM9 14.75a.763.763 0 0 1-.183-.022l-4-1a.75.75 0 1 1 .364-1.456l4 1A.75.75 0 0 1 9 14.75zM9 17.75a.763.763 0 0 1-.183-.022l-4-1a.75.75 0 0 1 .364-1.456l4 1A.75.75 0 0 1 9 17.75zM9 8.75a.763.763 0 0 1-.183-.022l-4-1a.75.75 0 1 1 .364-1.456l4 1A.75.75 0 0 1 9 8.75zM9 11.75a.763.763 0 0 1-.183-.022l-4-1a.75.75 0 1 1 .364-1.456l4 1A.75.75 0 0 1 9 11.75z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.eb587d0390a856a7aac5e485fab5491d.svg";
export { ForwardRef as ReactComponent };